import { render, staticRenderFns } from "./SpendingPowerChart.vue?vue&type=template&id=475c50b6&lang=pug"
import script from "./SpendingPowerChart.vue?vue&type=script&lang=js"
export * from "./SpendingPowerChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports